import React, { useState, useRef } from "react";
import styles from "./index.modules.less";
import EmptyIcon from "../../image/nosoft.svg";


const Empty = ({setOpen}) => {
    return (
        <div className={styles.wrapper}>
            <img className={styles.Empty} src="https://p5.ssl.qhimg.com/t010704196f3c6bae9b.png" />
            <div className={styles.EmptyText}>暂无联运软件，快去 <span onClick={() => setOpen(true)}>{`添加软件 >`}</span></div>
        </div>
    )
}

export default Empty;